import React from 'react'
import lang from '@/lang'
import { makeStyles } from '@mui/styles'
import CreateImage from './createImage'
import { Title } from '@/modules/base/components/texts'
const { cleverreach: cleverreachLang } = lang

const InitialView = (props) => {
  const { syncDetails, subTitle } = props
  const classes = useStyles()

  return (
    <>
      <Title size='extraLarge' marginBottom='30px' position='center' fontWeight='mediumbold'>{cleverreachLang.mainTitle} </Title>
      <div className={classes.mainSubtitle}>{ subTitle }</div>
      <CreateImage syncDetails={syncDetails} />
    </>
  )
}

const useStyles = makeStyles(theme => ({
  mainSubtitle: {
    marginBottom: 60,
    fontSize: 16,
    listHeight: 26,
  },
}))

export default InitialView
